
































import {Component, Mixins} from 'vue-property-decorator'
import OrderView from './OrderView.vue'
import orderByTokenMixin from "@/mixins/orderByTokenMixin";
import {ICheckoutResponse, IOrder, Checkout} from "@/entities";
import {getError, mountScript} from "@/lib";
import {Location} from "vue-router";
import {Dictionary} from "vue-router/types/router";
declare var Stripe: any;

@Component({
  components: {
    OrderView
  }
})
export default class CheckoutPage extends Mixins(orderByTokenMixin) {

  private error: string = '';
  private redirecting: boolean = false;

  protected initFetches = [
    this.getOrderAndCheckout,
    this.mountStripe
  ];

  get toOrder(): Location | undefined {
    let order = this.order;
    return order ? { name: 'Order', params: { token: order.token }} : undefined;
  }

  private toOrderWithResult(query: Dictionary<string>): void {
    let to = this.toOrder;
    this.$router.push({
      ...(to || {}),
      query: {
        ...to?.query,
        ...query
      }
    });
  }

  private fetchOrder(): Promise<IOrder | undefined> {
    return new Promise<IOrder | undefined>((resolve, reject) => {
      this.fetchOrderByToken()
        .then((res: IOrder | undefined) => {
          if (res) {
            resolve(res);
          } else {
            reject();
          }
        })
        .catch((reason) => {
          reject(reason);
        });
    });
  }

  private getOrder(): Promise<IOrder> {
    return new Promise<IOrder>((resolve, reject) => {
      // check in the store
      let order = this.$storage.getters.getOrder();
      if (order) {
        this.data = order;
        resolve(order);
      } else {
        return this.fetchOrder()
          .then((res: IOrder | undefined) => {
            if (res) {
              resolve(res);
            } else {
              reject();
            }
          })
          .catch(reject);
      }
    });
  }

  private getOrderAndCheckout(): void {
    this.getOrder()
      .then((res: IOrder) => {
        switch (res.status) {
          case "waiting":
            this.checkoutOrder(res);
            break;
          case "done":
          case "paid":
            // go to the order with 'paid' message
            this.toOrderWithResult({
              payment: 'paid'
            });
            break;
          default:
            // go to the order with 'early' message
            this.toOrderWithResult({
              payment: 'early'
            });
        }
      });
  }

  private checkoutOrder(order: IOrder): void {
    this.redirecting = true;
    this.$storage.actions.checkout(new Checkout(order))
      .then((res: ICheckoutResponse) => {
        Stripe(res.pk).redirectToCheckout({ sessionId: res.session_id });
      })
      .catch(reason => {
        // error getting checkout from back
        let res = reason.response;
        if (res.status === 424) {
          // too early to pay
          this.toOrderWithResult({
            payment: res.data?.status || 'early'
          });
        } else {
          this.error = getError(reason);
        }
      });
  }

  mountStripe() {
    mountScript('https://js.stripe.com/v3/');
  }

}
